import {BaseApiService} from "../BaseApiService";
import {ILoginRequest} from "./request/LoginRequest";
import {CookieManager} from "../../utility/CookieManager";

export class AccountApiService extends BaseApiService<object> {

    constructor() {
        super("Account");
    }

    public checkAuth() {

        const url = this.prefixUrl + "/CheckAuth";

        return this.postRequest(url, '');
    }

    public login(data: ILoginRequest) {

        const url = this.prefixUrl + '/Login';
        const jsonData = JSON.stringify(data);
        const successResponse = (response: any) => {
            CookieManager.setSession(response.result);
        };

        return this.postRequest(url, jsonData, successResponse);
    }

    public register(data: any){

        const url = this.prefixUrl + '/Register';
        const jsonData = JSON.stringify(data);
        const successResponse = (response: any) => {
            CookieManager.setSession(response.result);
        };

        return this.postRequest(url, jsonData, successResponse);
    }

    public changePassword(data: any) {

        const url = this.prefixUrl + '/ChangePassword';
        const jsonData = JSON.stringify(data);

        return this.postRequest(url, jsonData);
    }

}


// WEBPACK FOOTER //
// ./src/core/api/account/AccountApiService.tsx